console.log("CX")

// var prorec = document.querySelector('.related-products')

// window.addEventListener('load', function() {
//   setTimeout(function() {
//     $('.rec-slider').slick({
// dots: true,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 4,
//   slidesToScroll: 4,
//   responsive: [
//     {
//       breakpoint: 1200,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         infinite: true,
//         dots: true
//       }
//     },
//     {
//       breakpoint: 920,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2,
//         infinite: true,
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         infinite: true,
//       }
//     }
//   ]
//     });
//     // Get cards
// var cards = $('.card__information');
// var maxHeight = 0;

// // Loop all cards and check height, if bigger than max then save it
// for (var i = 0; i < cards.length; i++) {
//   if (maxHeight < $(cards[i]).outerHeight()) {
//     maxHeight = $(cards[i]).outerHeight();
//   }
// }
// // Set ALL card bodies to this height
// for (var i = 0; i < cards.length; i++) {
//   $(cards[i]).height(maxHeight-50);
// }
//   }, 3000);
// });

